/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { AdminChatTokenLimitDto } from '../model/adminChatTokenLimitDto';
import { AdminChatTokenLimitRequestDto } from '../model/adminChatTokenLimitRequestDto';
import { AdminPagedResponseDto } from '../model/adminPagedResponseDto';
import { AdminPagedResponseDtoAdminUserDetailDto } from '../model/adminPagedResponseDtoAdminUserDetailDto';
import { AdminUserDetailDto } from '../model/adminUserDetailDto';
import { AdminUserInviteRequestDto } from '../model/adminUserInviteRequestDto';
import { AdminUserUpdateRequestDto } from '../model/adminUserUpdateRequestDto';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class AdminUserManagementService {

    protected basePath = 'https://api.beta.planbic.de';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Benutzer aktivieren
     * Aktiviert einen Benutzer (Zugriff wird wiederhergestellt)
     * @param userId Benutzer ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public activateUser(userId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public activateUser(userId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public activateUser(userId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public activateUser(userId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling activateUser.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('put',`${this.basePath}/admin/users/${encodeURIComponent(String(userId))}/activate`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Benutzer deaktivieren
     * Deaktiviert einen Benutzer (Zugriff wird verweigert)
     * @param userId Benutzer ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deactivateUser(userId: number, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public deactivateUser(userId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public deactivateUser(userId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public deactivateUser(userId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling deactivateUser.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<any>('put',`${this.basePath}/admin/users/${encodeURIComponent(String(userId))}/deactivate`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Alle Benutzer abrufen
     * Gibt eine paginierte Liste aller registrierten Benutzer zurück
     * @param page Seitenzahl (0-indexed)
     * @param pageSize Anzahl der Einträge pro Seite
     * @param sortBy Sortierfeld
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllUsers(page?: number, pageSize?: number, sortBy?: string, observe?: 'body', reportProgress?: boolean): Observable<AdminPagedResponseDto>;
    public getAllUsers(page?: number, pageSize?: number, sortBy?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminPagedResponseDto>>;
    public getAllUsers(page?: number, pageSize?: number, sortBy?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminPagedResponseDto>>;
    public getAllUsers(page?: number, pageSize?: number, sortBy?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('pageSize', <any>pageSize);
        }
        if (sortBy !== undefined && sortBy !== null) {
            queryParameters = queryParameters.set('sortBy', <any>sortBy);
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AdminPagedResponseDto>('get',`${this.basePath}/admin/users`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * chatBIC-Monatskontingent abrufen
     * Verbrauch, Limit und ob das Limit erreicht ist
     * @param userId Benutzer ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getChatTokenLimit(userId: number, observe?: 'body', reportProgress?: boolean): Observable<AdminChatTokenLimitDto>;
    public getChatTokenLimit(userId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminChatTokenLimitDto>>;
    public getChatTokenLimit(userId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminChatTokenLimitDto>>;
    public getChatTokenLimit(userId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling getChatTokenLimit.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AdminChatTokenLimitDto>('get',`${this.basePath}/admin/users/${encodeURIComponent(String(userId))}/chat-token-limit`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Benutzerdetails abrufen
     * Gibt detaillierte Informationen zu einem spezifischen Benutzer zurück
     * @param userId Benutzer ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUserById(userId: number, observe?: 'body', reportProgress?: boolean): Observable<AdminUserDetailDto>;
    public getUserById(userId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminUserDetailDto>>;
    public getUserById(userId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminUserDetailDto>>;
    public getUserById(userId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling getUserById.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AdminUserDetailDto>('get',`${this.basePath}/admin/users/${encodeURIComponent(String(userId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Account einladen
     * Legt einen deaktivierten Account an und schickt die Registrierungsmail
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public inviteUser(body?: AdminUserInviteRequestDto, observe?: 'body', reportProgress?: boolean): Observable<AdminUserDetailDto>;
    public inviteUser(body?: AdminUserInviteRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminUserDetailDto>>;
    public inviteUser(body?: AdminUserInviteRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminUserDetailDto>>;
    public inviteUser(body?: AdminUserInviteRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AdminUserDetailDto>('post',`${this.basePath}/admin/users`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * chatBIC-Token-Verbrauch zuruecksetzen
     * Verschiebt den Zaehlbeginn auf jetzt und hebt eine Verbrauchssperre auf
     * @param userId Benutzer ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public resetChatTokenUsage(userId: number, observe?: 'body', reportProgress?: boolean): Observable<AdminChatTokenLimitDto>;
    public resetChatTokenUsage(userId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminChatTokenLimitDto>>;
    public resetChatTokenUsage(userId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminChatTokenLimitDto>>;
    public resetChatTokenUsage(userId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling resetChatTokenUsage.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AdminChatTokenLimitDto>('put',`${this.basePath}/admin/users/${encodeURIComponent(String(userId))}/chat-token-usage/reset`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Benutzer suchen
     * Sucht Benutzer nach Email oder Name
     * @param query Suchbegriff
     * @param page Seitenzahl (0-indexed)
     * @param pageSize Anzahl der Einträge pro Seite
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public searchUsers(query: string, page?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean): Observable<AdminPagedResponseDtoAdminUserDetailDto>;
    public searchUsers(query: string, page?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminPagedResponseDtoAdminUserDetailDto>>;
    public searchUsers(query: string, page?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminPagedResponseDtoAdminUserDetailDto>>;
    public searchUsers(query: string, page?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (query === null || query === undefined) {
            throw new Error('Required parameter query was null or undefined when calling searchUsers.');
        }



        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (query !== undefined && query !== null) {
            queryParameters = queryParameters.set('query', <any>query);
        }
        if (page !== undefined && page !== null) {
            queryParameters = queryParameters.set('page', <any>page);
        }
        if (pageSize !== undefined && pageSize !== null) {
            queryParameters = queryParameters.set('pageSize', <any>pageSize);
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<AdminPagedResponseDtoAdminUserDetailDto>('get',`${this.basePath}/admin/users/search`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * chatBIC-Monatskontingent setzen
     * Setzt das monatliche Token-Limit und hebt eine Verbrauchssperre auf, wenn der Verbrauch darunter liegt. Ohne Wert (null) gilt kein Limit.
     * @param body 
     * @param userId Benutzer ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public setChatTokenLimit(body: AdminChatTokenLimitRequestDto, userId: number, observe?: 'body', reportProgress?: boolean): Observable<AdminChatTokenLimitDto>;
    public setChatTokenLimit(body: AdminChatTokenLimitRequestDto, userId: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminChatTokenLimitDto>>;
    public setChatTokenLimit(body: AdminChatTokenLimitRequestDto, userId: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminChatTokenLimitDto>>;
    public setChatTokenLimit(body: AdminChatTokenLimitRequestDto, userId: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling setChatTokenLimit.');
        }

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling setChatTokenLimit.');
        }

        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AdminChatTokenLimitDto>('put',`${this.basePath}/admin/users/${encodeURIComponent(String(userId))}/chat-token-limit`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Account-Stammdaten aendern
     * Vorname, Nachname, Mailadresse. Fehlendes Feld bleibt unveraendert.
     * @param userId Benutzer ID
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateUser1(userId: number, body?: AdminUserUpdateRequestDto, observe?: 'body', reportProgress?: boolean): Observable<AdminUserDetailDto>;
    public updateUser1(userId: number, body?: AdminUserUpdateRequestDto, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<AdminUserDetailDto>>;
    public updateUser1(userId: number, body?: AdminUserUpdateRequestDto, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<AdminUserDetailDto>>;
    public updateUser1(userId: number, body?: AdminUserUpdateRequestDto, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (userId === null || userId === undefined) {
            throw new Error('Required parameter userId was null or undefined when calling updateUser1.');
        }


        let headers = this.defaultHeaders;

        // authentication (azure_oauth2) required
        if (this.configuration.accessToken) {
            const accessToken = typeof this.configuration.accessToken === 'function'
                ? this.configuration.accessToken()
                : this.configuration.accessToken;
            headers = headers.set('Authorization', 'Bearer ' + accessToken);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            '*/*'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<AdminUserDetailDto>('put',`${this.basePath}/admin/users/${encodeURIComponent(String(userId))}`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
